import styled from "styled-components";
import media from "constants/media";

export const Container = styled.div`
    position: relative;

    display: flex;

    flex-direction: column;

    max-width: 980px;
    margin: 0 auto;

    background: var(--color-white);

    ${media.mdUp`
        flex-direction: row;
    `}
`;

export const Partial = styled.div`
    width: 100%;
    padding: 40px 20px;

    &:last-of-type {
        padding-top: 0;
    }

    &:first-of-type {
        padding-top: 40px;
    }

    ${media.mdUp`
        width: 50%;
        padding: 40px;

        &:first-of-type {
            background: var(--color-athensGrey);
        }

        &:first-of-type, &:last-of-type {
            padding-top: 40px;
        }
    `}
`;

export const Close = styled.button`
    position: absolute;
    top: 20px;
    right: 20px;

    width: 12px;

    cursor: pointer;

    svg {
        width: 100%;
    }
`;

export const Title = styled.h2`
    margin-bottom: 10px;

    font-size: 25px;
    font-family: var(--font-DINProCondensed);
    line-height: 30px;
    letter-spacing: 1px;
    text-transform: uppercase;

    ${media.mdUp`
        margin-bottom: 18px;

        font-size: 32px;
        line-height: 40px;
    `}
`;

export const SmallTitle = styled.h4`
    margin-bottom: 25px;

    font-weight: normal;
    font-size: 20px;
    line-height: 25px;

    ${media.mdUp`
        line-height: 30px;
    `}
`;

export const Maps = styled.div`
    height: 400px;
    margin: 0 -20px;
    margin-bottom: -20px;

    background: var(--colors-lightGrey);

    ${media.mdUp`
        margin: 0;
        margin-top: 20px;
        margin-bottom: 0;
    `}
`;
